import { PassedInitialConfig } from 'angular-auth-oidc-client';

export enum Environment {
    Local = 'local',
    Dev = 'dev',
    Qa = 'qa',
    Prod = 'prod',
}

export interface AppConfig {
    production: boolean;
    env: Environment;
    auth: PassedInitialConfig;
    webchat: {
        baseUrl: string;
        scriptUrl: string;
        apiKey: string;
        showSessionId?: boolean;
        useStreaming?: boolean;
    };
}
